<template>
  <div class="space-y-8">
    <h3 class="text-lg leading-6 font-medium text-gray-900">Customer</h3>
    <table class="min-w-full">
      <tbody class="relative">
        <tr>
          <td
            class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border"
          >
            Name
          </td>
          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border text-right">
            {{ customer }}
          </td>
        </tr>
        <tr>
          <td
            class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border"
          >
            Email
          </td>
          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border text-right">
            {{ email }}
          </td>
        </tr>
        <tr>
          <td
            class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border"
          >
            Phone
          </td>
          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border text-right">
            {{ phone }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    accOrder: {
      type: Object,
      required: true,
    },
  },
  computed: {
    contact() {
      return this.$store.state.entities.contacts.byId[this.accOrder.contactId];
    },
    customer() {
      return `${this.contact.firstName} ${this.contact.lastName}`;
    },
    email() {
      return this.contact.email || '-';
    },
    phone() {
      return this.contact.phone || '-';
    },
  },
};
</script>
